var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobotIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "robot-icon",
    transform: "translate(-12 -12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Icon",
    width: 56,
    height: 56,
    rx: 7,
    transform: "translate(12 12)",
    fill: "#f0f1fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_bot",
    d: "M20.44,3.978a1.211,1.211,0,0,0-1.15,1.263V6.487H13.84a3.63,3.63,0,0,0-3.5,3.735v7.471a3.63,3.63,0,0,0,3.5,3.735H27.076a3.63,3.63,0,0,0,3.5-3.735V10.222a3.63,3.63,0,0,0-3.5-3.735h-5.45V5.241a1.289,1.289,0,0,0-.343-.9,1.131,1.131,0,0,0-.844-.364Zm-3.486,7.489a2.079,2.079,0,1,1-1.947,2.075A2.014,2.014,0,0,1,16.954,11.467Zm7.008,0a2.079,2.079,0,1,1-1.947,2.075A2.014,2.014,0,0,1,23.962,11.467ZM11.5,23.918A3.63,3.63,0,0,0,8,27.654v.632a7.283,7.283,0,0,0,2.093,5.152C11.82,35.154,15.021,37.2,20.458,37.2s8.638-2.046,10.365-3.761a7.281,7.281,0,0,0,2.093-5.152v-.632a3.63,3.63,0,0,0-3.5-3.735Z",
    transform: "translate(18.626 19.021)",
    fill: "#1b1d29"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotIcon);
export default __webpack_public_path__ + "static/media/robot-icon.8bb315c837090d40d85e8442fd05c356.svg";
export { ForwardRef as ReactComponent };